import React from "react";
import { useNavigate } from "react-router-dom";
import { DateDisplay } from "../../Extra/DateDisplay";

export const EventItemSideBarOtherEvents = (props) => {
  const navigate = useNavigate();

  function clickHandler(eventItemId, slug) {
    let url = "/events/" + eventItemId + "/" + slug;
    navigate(url);
  }

  return (
    <div className="side-widget">
      <h5>More Events</h5>
      <ul className="other-news-list">
        {props.other.map((item, index) => {
          return (
            <li key={index} onClick={(e) => clickHandler(item.id, item.slug)}>
              <strong><a href={"/events/" + item.id + "/" + item.slug}>{item.title}</a></strong>
              <span className="pdate">
                <i className="fas fa-calendar-alt"></i>{" "}
                <DateDisplay datetime={item.starts_at_date} />
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
